<div>
  @if (isNativeDevice) {
      <div class="d-flex justify-content-center">
          <app-generic-button
            (click)="scanBarcode()"
            description="Scan device ID"
            [alwaysShowText]="true"
            [buttonClass]="'btn-info height-100px width-300px'"
            [buttonText]="'Scan code'"
            [primaryIcon]="'datamatrix.png'"
            class="w-100"/>
      </div>
      <div class="row d-flex flex-row justify-content-center">
          <hr class="col m-3"/>
          <div class="col-auto m-auto text-center">or</div>
          <hr class="col m-3"/>
      </div>
  }
  <div class="background-pure-white rounded-3 p-3 d-flex flex-column gap-3">
      @if (showImage()) {
        <div class="d-flex justify-content-center">
            <img alt="tag-image" height="116" ngSrc="tag_image.png" width="90">
        </div>
      }
      <div class="text-center">Enter the (last) {{ inputLength() }} characters of the code found on the back of the mOOvement {{ deviceName() }}.</div>
      <div #inputWrapper class="d-flex justify-content-center flex-wrap">
        @for (i of indexes(); track i) {
            <input (input)="addDeviceIdPart(i, $event)"
                [value]="deviceIdParts().at(i)"
                (keydown)="keydown($event)"
                class="m-1 p-1 rounded-2 square-input text-center"
                maxlength="1"
                type="text"/>
        }
        </div>
        @if (manualInputStarted()) {
            <app-generic-button
                (click)="clearInput()"
                description="Clear manual device ID"
                [alwaysShowText]="true"[buttonClass]="'btn-info height-100px width-300px'"
                [buttonText]="'Reset'"
                [primaryIcon]="'fa-solid fa-recycle'"
                class="w-100"/>
        }
        @if (manualInputCompleted()) {
            <app-generic-button
                (click)="acceptManualDeviceId()"
                description="Accept manual device ID"
                [alwaysShowText]="true"
                [buttonClass]="'btn-info height-100px width-300px'"
                [buttonText]="'Accept input'"
                [primaryIcon]="'fa-solid fa-check'"
                class="w-100"/>
        }
  </div>
</div>
